import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ClockIcon, ArrowLeftIcon } from 'lucide-react';
import { ServiceNowSubNav } from '../components/ServiceNowSubNav';
import { Markdown } from '../components/Markdown';
import { getArticleBySlug } from '../data/articles';
const THOUGHT_LEADERSHIP_PATH = '/services/servicenow/thought-leadership';
export function ArticlePage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const article = getArticleBySlug(slug);
  if (!article) {
    return <div className="w-full" data-id="element-733" data-mp="irr03d7pxw2x">
        <ServiceNowSubNav data-id="element-734" data-mp="4yrp9oivsq1p" />
        <section className="section-white" data-id="element-735" data-mp="4zj962348zc5">
          <div className="max-w-[760px] mx-auto px-5 text-center" data-id="element-736" data-mp="4wexykr8h3bz">
            <h1 className="text-3xl font-bold text-nrs-navy mb-4" data-id="element-737" data-mp="9xuh279uozrq">
              Article Not Found
            </h1>
            <p className="text-gray-600 mb-8" data-id="element-738" data-mp="3r7j5g1woufs4">
              We couldn't find the article you're looking for.
            </p>
            <Link to={THOUGHT_LEADERSHIP_PATH} className="btn-primary" data-id="element-739" data-mp="2cwyy81nb7ues">
              <ArrowLeftIcon className="h-4 w-4 mr-2" data-id="element-740" data-mp="2cz1w17uperu2" />
              Back to Thought Leadership
            </Link>
          </div>
        </section>
      </div>;
  }
  return <div className="w-full" data-id="element-741" data-mp="2lwc6ws3m0eyg">
      <ServiceNowSubNav data-id="element-742" data-mp="2lvj8ceet0vre" />

      {/* ARTICLE */}
      <article className="section-white" data-id="element-743" data-mp="2hvsa5pmy7dcu">
        <div className="max-w-[760px] mx-auto px-5" data-id="element-744" data-mp="2hwtkfrw53vti">
          {/* Back link */}
          <Link to={THOUGHT_LEADERSHIP_PATH} className="inline-flex items-center gap-2 text-nrs-blue font-semibold text-sm hover:text-nrs-orange transition-colors mb-8" data-id="element-745" data-mp="1u78z52cikmh2">
            <ArrowLeftIcon className="h-4 w-4" data-id="element-746" data-mp="22z18f9psxpk2" />
            Back to Thought Leadership
          </Link>

          {/* Category pill + read time */}
          <div className="flex items-center gap-3 mb-4" data-id="element-747" data-mp="1y5yc4ttn4206">
            <span className={`px-2 py-0.5 text-xs font-semibold rounded-full ${article.tagColor}`} data-id="element-748" data-mp="1ahoywgahsmkn">
              {article.tag}
            </span>
            <div className="flex items-center gap-1 text-gray-400 text-xs" data-id="element-749" data-mp="16esjeyg916kx">
              <ClockIcon className="h-3 w-3" data-id="element-750" data-mp="35l3oixjtashd" />
              {article.readTime}
            </div>
          </div>

          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-nrs-navy leading-tight mb-8" data-id="element-751" data-mp="3fbg74k82gbkv">
            {article.title}
          </motion.h1>

          {/* Body */}
          <div className="border-t border-gray-200 pt-8" data-id="element-752" data-mp="2rmwxo1da5sr7">
            <Markdown content={article.body} data-id="element-753" data-mp="2wkyj2sy6i45u" />
          </div>
        </div>
      </article>

      {/* CLOSING CTA */}
      <section className="section-navy" data-id="element-754" data-mp="31kkvj066ngdl">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-755" data-mp="31lmh3yktrl9k">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-756" data-mp="bty02f04b8li">
            Talk to Us About Your Platform
          </h2>
          <div className="h-1 w-16 bg-nrs-orange mx-auto rounded-full mb-8" data-id="element-757" data-mp="grzjj11gh9xi"></div>
          <p className="text-xl text-nrs-light mb-8 max-w-2xl mx-auto" data-id="element-758" data-mp="21ajummrk3h7j">
            Free 30-minute assessment, no commitment required. Or start with our
            self-assessment to score your platform's technical debt risk.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-759" data-mp="1rjp6tdynw9jz">
            <a href="mailto:info@newriversystems.com" className="btn-primary" data-id="element-760" data-mp="1mmp0r31tb6sv">
              Talk to Us
            </a>
            <Link to="/services/servicenow/calculator" className="btn-secondary" data-id="element-761" data-mp="1hlj6v1wf1dhr">
              Try the Risk Calculator
            </Link>
          </div>
        </div>
      </section>
    </div>;
}